<template>
    <AboutHead :headline-blue="$t('charts_page_sub_update')" :headline="$t('charts_page_head_update')" />

    <div class="mx-5 xl:mx-auto xl:container md:mt-[-40px] lg:mt-[-40px] z-10 pb-8">
        <div class="rounded-md bg-white shadow-lg w-full h-auto mx-auto">
            <div class="relative aspect-[33/16] py-1 lg:py-3">
                <Transition name="fade">
                    <img :key="chartImg" class="absolute top-0 w-full mx-auto rounded-lg shadow-lg" :src="$asset(chartImg, 'public')" alt="HKCM Chart" title="HKCM Chart" />
                </Transition>
                <div
                    class="absolute flex items-center left-[13.5%] top-[49%] w-[22px] md:w-[3.3%] aspect-square shadow-lg border-blue cursor-pointer z-1 transition-all duration-200 ease-in-out border md:border-4 rounded-lg"
                    :class="[activeTab === 1 ? 'bg-blue text-white' : '', activeChartIdx === 1 ? 'border-2 md:border-[7px] rounded-2xl' : '']"
                    @mouseover="chartOnHoverEnter(1)"
                    @mouseleave="chartOnHoverLeave()"
                    @click="chartOnClick(1)"
                >
                    <div class="m-auto max-h-full align-middle font-semibold text-[12px] lg:text-base text-blue z-1" :class="activeTab === 1 ? 'text-white' : ''">1</div>
                </div>
                <p
                    class="absolute align-right left-[6.3%] top-[43%] font-semibold text-[1.6vw] lg:text-lg text-blue z-0 transition-all duration-200 ease-in-out"
                    :class="activeChartIdx === 1 ? 'opacity-100' : ' opacity-0'"
                >
                    {{ $t(tabs[1].title) }}
                </p>
                <div
                    class="absolute flex items-center left-[20%] top-[9%] w-[22px] md:w-[3.3%] aspect-square shadow-lg border-blue cursor-pointer transition-all duration-200 ease-in-out border md:border-4 rounded-lg"
                    :class="[activeTab === 2 ? 'bg-blue text-white' : '', activeChartIdx === 2 ? 'border-2 md:border-[7px] rounded-2xl' : '']"
                    @mouseover="chartOnHoverEnter(2)"
                    @mouseleave="chartOnHoverLeave()"
                    @click="chartOnClick(2)"
                >
                    <div class="m-auto max-h-full align-middle font-semibold text-[12px] lg:text-base text-blue" :class="activeTab === 2 ? 'text-white' : ''">2</div>
                </div>
                <p
                    class="absolute align-right left-[14%] top-[3.4%] font-semibold text-[1.6vw] lg:text-lg text-blue z-0 transition-all duration-200 ease-in-out"
                    :class="activeChartIdx === 2 ? 'opacity-100' : ' opacity-0'"
                >
                    {{ $t(tabs[2].title) }}
                </p>
                <div
                    class="absolute flex items-center left-[47%] top-[66%] w-[22px] md:w-[3.3%] aspect-square shadow-lg border-blue cursor-pointer transition-all duration-200 ease-in-out border md:border-4 rounded-lg"
                    :class="[activeTab === 3 ? 'bg-blue text-white' : '', activeChartIdx === 3 ? 'border-2 md:border-[7px] rounded-2xl' : '']"
                    @mouseover="chartOnHoverEnter(3)"
                    @mouseleave="chartOnHoverLeave()"
                    @click="chartOnClick(3)"
                >
                    <div class="m-auto max-h-full align-middle font-semibold text-[12px] lg:text-base text-blue" :class="activeTab === 3 ? 'text-white' : ''">3</div>
                </div>
                <p
                    class="absolute align-right left-[36%] top-[74%] font-semibold text-[1.6vw] lg:text-lg text-blue z-0 transition-all duration-200 ease-in-out"
                    :class="activeChartIdx === 3 ? 'opacity-100' : ' opacity-0'"
                >
                    {{ $t(tabs[3].title) }}
                </p>
                <div
                    class="absolute flex items-center left-[71.5%] top-[31%] w-[22px] md:w-[3.3%] aspect-square shadow-lg border-blue cursor-pointer transition-all duration-200 ease-in-out border md:border-4 rounded-lg"
                    :class="[activeTab === 4 ? 'bg-blue text-white' : '', activeChartIdx === 4 ? 'border-2 md:border-[7px] rounded-2xl' : '']"
                    @mouseover="chartOnHoverEnter(4)"
                    @mouseleave="chartOnHoverLeave()"
                    @click="chartOnClick(4)"
                >
                    <div class="m-auto max-h-full align-middle font-semibold text-[12px] lg:text-base text-blue" :class="activeTab === 4 ? 'text-white' : ''">4</div>
                </div>
                <p
                    class="absolute align-right left-[66%] top-[25.5%] font-semibold text-[1.6vw] lg:text-lg text-blue z-0 transition-all duration-200 ease-in-out"
                    :class="activeChartIdx === 4 ? 'opacity-100' : ' opacity-0'"
                >
                    {{ $t(tabs[4].title) }}
                </p>
                <div
                    class="absolute flex items-center left-[76%] top-[82%] w-[22px] md:w-[3.3%] aspect-square shadow-lg border-blue cursor-pointer transition-all duration-200 ease-in-out border md:border-4 rounded-lg"
                    :class="[activeTab === 5 ? 'bg-blue text-white' : '', activeChartIdx === 5 ? 'border-2 md:border-[7px] rounded-2xl' : '']"
                    @mouseover="chartOnHoverEnter(5)"
                    @mouseleave="chartOnHoverLeave()"
                    @click="chartOnClick(5)"
                >
                    <div class="m-auto max-h-full align-middle font-semibold text-[12px] lg:text-base text-blue" :class="activeTab === 5 ? 'text-white' : ''">5</div>
                </div>
                <p
                    class="absolute align-right left-[81%] top-[86%] font-semibold text-[1.6vw] lg:text-lg text-blue z-0 transition-all duration-200 ease-in-out"
                    :class="activeChartIdx === 5 ? 'opacity-100' : ' opacity-0'"
                >
                    {{ $t(tabs[5].title) }}
                </p>
                <div
                    class="absolute flex items-center left-[92.5%] top-[66%] w-[22px] md:w-[3.3%] aspect-square shadow-lg border-blue cursor-pointer transition-all duration-200 ease-in-out border md:border-4 rounded-lg"
                    :class="[activeTab === 6 ? 'bg-blue text-white' : '', activeChartIdx === 6 ? 'border-2 md:border-[7px] rounded-2xl' : '']"
                    @mouseover="chartOnHoverEnter(6)"
                    @mouseleave="chartOnHoverLeave()"
                    @click="chartOnClick(6)"
                >
                    <div class="m-auto max-h-full align-middle font-semibold text-[12px] lg:text-base text-blue" :class="activeTab === 6 ? 'text-white' : ''">6</div>
                </div>
                <p
                    class="absolute align-right left-[84%] top-[73.5%] font-semibold text-[1.6vw] lg:text-lg text-blue z-0 transition-all duration-200 ease-in-out"
                    :class="activeChartIdx === 6 ? 'opacity-100' : ' opacity-0'"
                >
                    {{ $t(tabs[6].title) }}
                </p>
                <div
                    class="absolute flex items-center left-[92.5%] top-[26.5%] w-[22px] md:w-[3.3%] aspect-square shadow-lg border-blue cursor-pointer transition-all duration-200 ease-in-out border md:border-4 rounded-lg"
                    :class="[activeTab === 7 ? 'bg-blue text-white' : '', activeChartIdx === 7 ? 'border-2 md:border-[7px] rounded-2xl' : '']"
                    @mouseover="chartOnHoverEnter(7)"
                    @mouseleave="chartOnHoverLeave()"
                    @click="chartOnClick(7)"
                >
                    <div class="m-auto max-h-full align-middle font-semibold text-[12px] lg:text-base text-blue" :class="activeTab === 7 ? 'text-white' : ''">7</div>
                </div>
                <p
                    class="absolute align-right left-[83%] top-[33.5%] font-semibold text-[1.6vw] lg:text-lg text-blue z-0 transition-all duration-200 ease-in-out"
                    :class="activeChartIdx === 7 ? 'opacity-100' : ' opacity-0'"
                >
                    {{ $t(tabs[7].title) }}
                </p>
            </div>
            <p v-if="activeTab === 0" class="text-center p-5" data-aos="zoom-in" data-aos-duration="250">
                {{ $t('charts_page_empty_state') }}
            </p>
            <TabsHorizontal ref="horTab" v-model:data="tabs" v-model:active-tab="activeTab" active-color="#000000" :first-on-load="true">
                <template #header="{ data, activeTabIndex, key }">
                    <div class="rounded px-1 text-xs md:text-base font-semibold flex space-x-0 lg:space-x-1 leading-7 select-none" :class="key === 0 ? 'hidden' : ''">
                        <p
                            class="text-blue text-center px-1 rounded-md whitespace-nowrap transition-all duration-500 ease-in-out"
                            :class="activeTabIndex === key ? 'bg-blue text-white' : ''"
                        >
                            &nbsp; {{ key + 0 }} &nbsp;
                        </p>
                        &nbsp;
                        <p
                            :class="[
                                'hover:bg-zinc-200 px-1 rounded  text-xs transition-all duration-500 ease-in-out lg:block whitespace-nowrap',
                                activeTab !== 0 && 'hidden',
                                activeChartIdx === key ? 'bg-zinc-200' : ''
                            ]"
                            @mouseover="chartOnHoverEnter(key)"
                            @mouseleave="chartOnHoverLeave()"
                        >
                            {{ $t(data.title) }}
                        </p>
                    </div>
                </template>

                <template #item="{ data }">
                    <div v-if="data.copy || data.title" class="rounded-lg shadow-lg m-1 p-1 lg:mx-4 lg:my-1 lg:p-4 h-auto grow text-center">
                        <h2 class="xl_bold px-1 rounded-md font-semibold" data-aos="fade-in">
                            {{ $t(data.title) }}
                        </h2>
                        <p class="text-left p-1 lg:p-4" data-aos="fade-in" v-html="$t(data.copy)" />
                    </div>
                </template>
            </TabsHorizontal>
        </div>

        <Disclaimer class="mt-6" />
    </div>
</template>

<script>
import Disclaimer from '../components/customer/Disclaimer.vue';

export default {
    components: {
        Disclaimer
    },
    data() {
        return {
            subline: 'charts_page_subline',
            activeTab: 0,
            activeChartIdx: 0
        };
    },
    computed: {
        chartImg() {
            return this.tabs[this.activeChartIdx].img;
        },
        global() {
            return window.meta?.region_configuration?.region !== 'de';
        },
        tabs() {
            return [
                {
                    title: '',
                    img: `/hkcm/images/ourcharts/0${this.global ? '_GLO' : ''}.svg`,
                    copy: ''
                },
                {
                    title: 'charts_page_price_waves_leading',
                    img: `/hkcm/images/ourcharts/1${this.global ? '_GLO' : ''}.svg`,
                    copy: 'charts_page_price_waves_text _update'
                },
                {
                    title: 'charts_page_target_zones_leading',
                    img: `/hkcm/images/ourcharts/2${this.global ? '_GLO' : ''}.svg`,
                    copy: 'charts_page_target_zones_text_update'
                },
                {
                    title: 'charts_page_trading_ranges_leading_update',
                    img: `/hkcm/images/ourcharts/3${this.global ? '_GLO' : ''}.svg`,
                    copy: 'charts_page_trading_ranges_text_update'
                },
                {
                    title: 'charts_page_primary_scenarios_leading',
                    img: `/hkcm/images/ourcharts/4${this.global ? '_GLO' : ''}.svg`,
                    copy: 'charts_page_primary_scenarios_text_update'
                },
                {
                    title: 'charts_page_alternative_scenarios_leading',
                    img: `/hkcm/images/ourcharts/5${this.global ? '_GLO' : ''}.svg`,
                    copy: 'charts_page_alternative_scenarios_text_update'
                },
                {
                    title: 'charts_page_support_leading',
                    img: `/hkcm/images/ourcharts/6${this.global ? '_GLO' : ''}.svg`,
                    copy: 'charts_page_support_text_update'
                },
                {
                    title: 'charts_page_resistances_leading',
                    img: `/hkcm/images/ourcharts/7${this.global ? '_GLO' : ''}.svg`,
                    copy: 'charts_page_resistances_text_update'
                }
            ];
        }
    },
    watch: {
        activeTab(activeTab) {
            this.activeChartIdx = activeTab;
        }
    },
    methods: {
        chartOnHoverEnter(chartIdx) {
            this.activeChartIdx = chartIdx;
        },
        chartOnHoverLeave() {
            this.activeChartIdx = this.activeTab;
        },
        chartOnClick(chartIdx) {
            this.$refs.horTab.onClick(chartIdx);
        }
    }
};
</script>

<style scoped>
.fade-enter-active {
    transition: opacity 300ms ease-in-out;
}

.fade-leave-active {
    transition: opacity 300ms ease-in-out;
}

.fade-enter-to {
    opacity: 1;
}

.fade-leave-to {
    opacity: 0;
}

.fade-enter {
    opacity: 0;
    z-index: 2;
}

.fade-leave {
    opacity: 1;
}
</style>
